export const environment = {
  production: true,
  currentEnvironment: 'production',
  BASE_API_URL: '/',
  SENTRY_DSN: 'https://f7a6004832fcab3aa453a0aa28e5c306@business.bcc.kz/3',
};
